// src/components/Valuation/PreliminaryDetailsTab.jsx
import React from "react";
import { Row, Col, Card, CardBody, Badge } from "reactstrap";

const BRAND_BLUE = "#0147C8";

const PreliminaryDetailsTab = ({ valuation }) => {
    if (!valuation) {
        return <p className="text-center text-muted">No valuation data available.</p>;
    }

    const project = valuation.project || {};
    const client = valuation.client || {};
    const valuer = valuation.valuer_user || {};
    const council = project.council || {};
    const district = council.district || {};
    const company = project.company || {};
    const category = project.project_category || {};

    const formatDate = (date) => {
        if (!date) return "-";
        try {
            return new Date(date).toLocaleDateString("en-GB");
        } catch {
            return date;
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "DRAFT": return "warning";
            case "SUBMITTED": return "primary"; // will use #0147C8 via inline style
            case "APPROVED": return "success";
            case "REJECTED": return "danger";
            default: return "secondary";
        }
    };

    return (
        <div className="p-3">
            {/* Valuation Overview */}
            <Card className="mb-4 shadow-sm border-0">
                <CardBody>
                    <h5 className="mb-3 fw-bold" style={{ color: BRAND_BLUE }}>
                        Valuation Overview
                    </h5>
                    <Row className="gy-3">
                        <Col md={6}><strong>Reference:</strong> {valuation.valuation_ref || "-"}</Col>
                        <Col md={6}>
                            <strong>Status:</strong>{" "}
                            <Badge
                                color="light"
                                style={{
                                    backgroundColor:
                                        valuation.valuation_status === "SUBMITTED"
                                            ? BRAND_BLUE
                                            : undefined,
                                    color:
                                        valuation.valuation_status === "SUBMITTED"
                                            ? "white"
                                            : undefined,
                                }}
                                className={getStatusColor(valuation.valuation_status) === "primary" ? "" : getStatusColor(valuation.valuation_status)}
                            >
                                {valuation.valuation_status || "UNKNOWN"}
                            </Badge>
                        </Col>
                        <Col md={6}><strong>Date:</strong> {formatDate(valuation.valuation_date)}</Col>
                        <Col md={6}><strong>Currency:</strong> {valuation.currency || "TZS"}</Col>
                        {valuation.notes && (
                            <Col md={12}>
                                <strong>Notes:</strong> <em>{valuation.notes}</em>
                            </Col>
                        )}
                    </Row>
                </CardBody>
            </Card>

            {/* Project Details */}
            <Card className="mb-4 shadow-sm border-0">
                <CardBody>
                    <h5 className="mb-3 fw-bold" style={{ color: BRAND_BLUE }}>
                        Project Details
                    </h5>
                    <Row className="gy-3">
                        <Col md={6}><strong>Name:</strong> {project.name || "-"}</Col>
                        <Col md={6}><strong>Code:</strong> {project.code || "-"}</Col>
                        <Col md={6}><strong>Category:</strong> {category.name || "-"}</Col>
                        <Col md={6}><strong>Council:</strong> {council.name || "-"}</Col>
                        <Col md={6}><strong>District:</strong> {district.name || "-"}</Col>
                        <Col md={6}><strong>Start Date:</strong> {formatDate(project.start_date)}</Col>
                        <Col md={6}><strong>End Date:</strong> {formatDate(project.end_date)}</Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Client */}
            <Card className="mb-4 shadow-sm border-0">
                <CardBody>
                    <h5 className="mb-3 fw-bold" style={{ color: BRAND_BLUE }}>
                        Client Details
                    </h5>
                    <Row className="gy-3">
                        <Col md={6}><strong>Name:</strong> {client.name || "-"}</Col>
                        <Col md={6}><strong>TIN:</strong> {client.tin || "-"}</Col>
                        <Col md={6}><strong>Type:</strong> {client.is_government ? "Government" : "Private"}</Col>
                        <Col md={6}><strong>Email:</strong> {client.email || "-"}</Col>
                        <Col md={6}><strong>Mobile:</strong> {client.mobile_number || "-"}</Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Contractor */}
            {company.name && (
                <Card className="mb-4 shadow-sm border-0">
                    <CardBody>
                        <h5 className="mb-3 fw-bold" style={{ color: BRAND_BLUE }}>
                            Contractor Details
                        </h5>
                        <Row className="gy-3">
                            <Col md={6}><strong>Name:</strong> {company.name}</Col>
                            <Col md={6}><strong>TIN:</strong> {company.tin || "-"}</Col>
                            <Col md={6}><strong>Email:</strong> {company.email || "-"}</Col>
                            <Col md={6}><strong>Mobile:</strong> {company.mobile_number || "-"}</Col>
                        </Row>
                    </CardBody>
                </Card>
            )}

            {/* Valuer */}
            <Card className="shadow-sm border-0">
                <CardBody>
                    <h5 className="mb-3 fw-bold" style={{ color: BRAND_BLUE }}>
                        Valuer Information
                    </h5>
                    <Row className="gy-3">
                        <Col md={6}>
                            <strong>Name:</strong>{" "}
                            {[valuer.first_name, valuer.middle_name, valuer.last_name]
                                .filter(Boolean)
                                .join(" ") || "-"}
                        </Col>
                        <Col md={6}><strong>Certificate Number:</strong> {valuer.certificate_number || "-"}</Col>
                        <Col md={6}><strong>Email:</strong> {valuer.email || "-"}</Col>
                        <Col md={6}><strong>Mobile:</strong> {valuer.mobile_number || "-"}</Col>
                        <Col md={6}><strong>Sex:</strong> {valuer.sex || "-"}</Col>
                        <Col md={6}><strong>Address:</strong> {valuer.address || "-"}</Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
};

export default PreliminaryDetailsTab;